import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { PERFORM_OFFER_ACTION_MUTATION } from '@applicant-flow/graphql';

export default function PerformOfferActionButton({
  offer,
  state,
  children,
  reason,
  size,
  danger,
  type = 'primary',
}) {
  const [performOfferAction, { loading }] = useMutation(
    PERFORM_OFFER_ACTION_MUTATION,
    {
      errorPolicy: 'all',
      onCompleted(data) {
        if (!data || !data.performOfferAction) return;
        createMessage('success', 'Offer successfully retracted!');
      },
      onError: () => {
        createMessage(
          'error',
          'Failed to update Offer state. Please try again or contact your hiring partner.'
        );
      },
    }
  );

  const clickToPerformOfferAction = () => {
    performOfferAction({
      variables: {
        offerId: offer.id,
        input: {
          action: state,
          reason: reason,
        },
      },
    }).then((response) => {
      if (response.errors && response.errors.length > 0) {
        createMessage('error', response.errors[0].message);
      }
    });
  };

  return (
    <Button
      type={type}
      onClick={clickToPerformOfferAction}
      size={size}
      danger={danger}
      loading={loading}
    >
      {children}
    </Button>
  );
}

PerformOfferActionButton.propTypes = {
  state: PropTypes.string.isRequired,
  offer: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  reason: PropTypes.string,
  size: PropTypes.string,
  danger: PropTypes.bool,
};
